import { motivoDelError } from './errores';

export const CODIGOS = {
  VENTANA: 'VENTANA_24H_CERRADA', PENDIENTE: 'ARCHIVO_PENDIENTE', NO_DISPONIBLE: 'ARCHIVO_NO_DISPONIBLE',
  CUOTA: 'CUOTA_LLENA', EN_CURSO: 'ENVIO_EN_CURSO', TIPO: 'TIPO_NO_ADMITIDO',
  GRANDE: 'ARCHIVO_DEMASIADO_GRANDE', CANAL: 'CANAL_NO_ADMITIDO', LIMITE: 'LIMITE_META',
  RECHAZADO: 'RECHAZADO_POR_META', ERROR_META: 'ERROR_META',
};

const MB = 1024 * 1024;
const NOMBRES = { whatsapp: 'WhatsApp', instagram: 'Instagram' };

// Los mismos que MediaAltaService.DOCUMENTOS_DE_WHATSAPP.
const DOCUMENTOS_DE_WHATSAPP = new Set([
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
]);

// El backend responde en dos formas: ProblemDetail ({detail, code}) y la del texto ({message, code}).
export const textoDelError = (data) => (data && (data.detail ?? data.message)) || null;
export const codigoDelError = (data) => (data && data.code) || null;

// Mismo formato que MediaAltaService.legible.
export const formatoMB = (bytes) => (bytes >= MB ? `${Math.floor(bytes / MB)} MB` : `${Math.floor(bytes / 1024)} KB`);

// Algún canal lo admite con ese MIME exacto: es uno de los que el backend detecta por contenido.
const esMimeConocido = (reglas, mime) => Object.values(reglas.canales)
  .some((lista) => (lista || []).some((r) => r.mime === mime));

// Con la extensión no basta: el backend detecta el tipo por contenido y es quien decide.
// Aquí solo se evita subir un archivo que seguro se rechazará. Un type que no figura en
// ninguna regla suele ser un alias del navegador (audio/x-m4a por audio/mp4) y pasa.
export const comprobarArchivo = (archivo, plataforma, reglas) => {
  if (!reglas) return null;
  if (archivo.size > reglas.maxBytesConsola) {
    return `La consola admite archivos de hasta ${Math.floor(reglas.maxBytesConsola / MB)} MB`;
  }
  const lista = reglas.canales[plataforma];
  if (!lista || !archivo.type) return null;
  const nombre = NOMBRES[plataforma];
  const regla = lista.find((r) => r.mime === archivo.type);
  if (!regla) {
    if (plataforma === 'instagram' && DOCUMENTOS_DE_WHATSAPP.has(archivo.type)) {
      return 'Instagram solo admite PDF como documento';
    }
    return esMimeConocido(reglas, archivo.type) ? `${nombre} no admite archivos ${archivo.type}` : null;
  }
  // Aquí no se sabe si es animado: se deja pasar hasta el mayor y el backend afina.
  const max = Math.max(regla.maxBytes, regla.maxBytesAnimado);
  return archivo.size > max ? `${archivo.type} supera el máximo de ${formatoMB(max)} en ${nombre}` : null;
};

export const motivoDelEnvio = (estado, data) =>
  textoDelError(data) || motivoDelError(estado, data, 'No se pudo enviar el archivo');
